<script type="text/jsx">
import { mapGetters } from 'vuex';
import { getMessageStringByRules } from '@/views/config/partner-refer/helper/validator';
import distributePlanLicenseMixin from '@/views/config/partner-refer/mixin/distribute-plan-license';

export default {
  mixins: [distributePlanLicenseMixin],
  computed: {
    ...mapGetters(['partnerRefer']),
    cartBottomBanner() {
      const content = getMessageStringByRules(this.partnerRefer?.cartBottomBannerContent);
      return this.replaceContentWithDynamicQuantity(content);
    },
    cartBottomSpecialOffer() {
      const content = getMessageStringByRules(this.partnerRefer?.cartBottomSpecialOfferContent);
      return this.replaceContentWithDynamicQuantity(content);

    },
  },
  methods: {
    renderBannerMode() {
      return <div domPropsInnerHTML={this.cartBottomBanner} />;
    },
    renderCardMode() {
      return <div domPropsInnerHTML={this.cartBottomSpecialOffer} />;
    },
  },
  render() {
    if (this.cartBottomBanner) {
      return this.renderBannerMode();
    }

    if (this.cartBottomSpecialOffer) {
      return this.renderCardMode();
    }

    return null;
  },
};
</script>

<style lang="scss">
.opc-partner-cart {
  &__banner-wrapper {
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #9ECEAD;
    background: #E6F5EC;
  }
}
</style>
